import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';
// import useMediaQuery from '@mui/material/useMediaQuery';

import { fetch_all_with_count, fetch_one } from "../../lib/v31lib";
import { loginAtom } from '../../lib/auth';

import Lenis from "lenis";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

import {
  Box,
  Grid,
} from '@mui/material';

import {
  Cta,
  FaqBlock,
  Footer,
  InputButton,
  Section,
  WhiteSection
} from '../../components/v2/custom';
import {
  LightGreenButton,
  Page,
  Typography
} from '../../components/v2/styled';
import { WideButton } from '../../components/v2/styled/WideButton';

// import { Faq as FaqItem } from '../../models/Faq';

// const { DateTime } = require("luxon");

type Props = {}

export const TestItsme: FunctionComponent<Props> = ({}) => {
  const [login, setLogin] = useAtom(loginAtom);
  // const theme = useTheme();
  // const navigate = useNavigate();
  // const {t, i18n} = useTranslation(['translations']);
  // const [searchParams, setSearchParams] = useSearchParams();

  const [itsmeUrl, setItsmeUrl] = useState<string>();








  const mutationCustomAction = useMutation({
    mutationFn: (pars: {
      formData: any;
    }) => {
      return fetch_one<{
        custom_result: any
      }>(
        `/nl/v3/pub/custom_action`,
        pars.formData,
        login
      );
    },
    onMutate: (pars: {
      formData: any;
    }) => {
      return true;
    },
    onError: (data, variables, context) => {
      return true;
    },
    onSuccess: (data, variables, context) => {
      console.log(data);
      if (data.custom_result) setItsmeUrl(data.custom_result);
    },
  });







  
  return <Page>
    <Grid container spacing={1}>
      <Grid item xs={12}>
        <Typography>Itsme testing</Typography>
      </Grid>
      <Grid item xs={12}>
        <LightGreenButton
          id="new_member"
          label="generate url"
          onClick={() => {
            mutationCustomAction.mutate({
              formData: {
                object: 'emission',
                class_action: 'custom_api_get_info',
                mode: 'itsme_test',
                for_live: 0
              }
            });
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Typography sx={{wordBreak: 'break-all'}}>Itsme url: {itsmeUrl}</Typography>
      </Grid>
    </Grid>
  </Page>;
}

